export class ValidatorPatterns {
	public static Alias = '^[0-9a-zA-ZÆØÅæøå\\-_./,#]+(?:\\s[0-9a-zA-ZÆØÅæøå\\-_./,#]+)*$';
	public static Description = '^[0-9a-zA-ZÆØÅæøå\\-_./,!()#]+(?:\\s[0-9a-zA-ZÆØÅæøå\\-_./,!()#]+)*$';
	public static Percentage = '^(100|[0-9]{1,2})$';
	public static DanishCharacters = '^[0-9a-zA-ZÆØÅæøå.,\\s]*$';
	public static MesTerminalFilterPattern = '^[0-9a-zA-ZÆØÅæøå\\-_./,#\\s]*$';
	public static ColorPattern = '^[a-zA-Z0-9,\\s\\-]*$';
	public static AllowedCuttingCharacters = '^[0-9a-zA-ZÆØÅæøå\\s-_]*$';
	public static GuidPattern = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$';
	public static NoStartOrEndWhitespacePattern = '^(?!\\s).*(?!\\s)$';
	public static WholeNumber = /^\d*$/;
	public static DecimalNumber = /^\d*,\d*$/;
	public static ZipCodeCharacters = /^(?!\s*$)[a-z0-9\-\s]*$/i;
	public static RFIDCharacters = /^[a-z0-9]+$/i;
}
